import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.TruncateRoot),
  () => import('./Truncate'),
  (Truncate) => {
    ComponentUtil.binder(Hooks.TruncateRoot, Truncate);
  },
);
